export default __webpack_public_path__ + "media/Family.7ce64c95.svg";